import { createCustomSearchParamsUpdater } from '@gonfalon/router/createCustomSearchParamsUpdater';

import { serializeProjectContextSearchParams } from './internal/serializeProjectContextSearchParams';
import { parseProjectContextSearchParams } from './parseProjectContextSearchParams';

export const projectContextSearchParamsUpdater = createCustomSearchParamsUpdater({
  parse: parseProjectContextSearchParams,
  serialize: serializeProjectContextSearchParams,
});
